















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import UtilsService from '@/modules/core/services/utils.service';


export interface TableHeader {
    key: string;
    value: string;
    style?: string;
}

@Component({
    name: 'table-component',
})
export default class TableComponent extends Vue {
    @Prop() private headers!: TableHeader[];
    @Prop() private list!: any[];


    private getValue(key: string, item: any) {
        return UtilsService.getObjectByString(item, key);
    }

}
